import react from "react"
import "./admin.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectAdminToken, selectSessionId, selectOrganizationId } from "./sessionSlice";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const sessionId = useSelector(selectSessionId);
  const organizationId = useSelector(selectOrganizationId);
  const gameId = useSelector((s) => s.auth?.user?.gameId ?? null);

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";

      const redirectGameSession=()=>{
        if (!gameId) return;
        window.location.href=process.env.REACT_APP_BASE_URL+"/active-games/"+gameId;
      }

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i class="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div class="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{adminToken === "admin&admin" && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Health Sprint </div>
          
         </div>
       
         
         <div className="user">
            <img src="/admin/user.png"/>
         </div>
       </div>
       {children}
      </div>
}

export default Admin;
